import c from "../../../utils/constants";

class ChecksFilterController {
  constructor($scope, FilterService, EventsService) {
    "ngInject"

    this.filterService = FilterService;
    this.eventsService = EventsService;

    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true)
  }

  $onInit() {
    this.setFilterOptions();

    this.eventsService.listen(c.events.GLOBAL_FILTER_APPLIED, (e, globalFilter) => {
      console.log("Checks global filter applied::", globalFilter);

      this.setFilterOptions(globalFilter.type);
    })

  }

  setFilterOptions(activeGlobalFilter) {
    this.filterOptions = this.filterService.getChecksFilterOptions(activeGlobalFilter);
    return this.filterOptions;
  }

  onFilterChagne(newval, oldval) {
    this.filterService.generateFilterExpression(this.filterOptions);
    this.applyFilters();
  }

}

export default ChecksFilterController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/checks-filter/checks-filter.controller.js
 **/